import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { useLocactionInfo } from '@/compositions/common'
import { getServiceOrderDetail } from '@/apis/malfunction-repair'
import { MalfunctionRepairState } from '@/store/malfunction-repair'
import {
  MalfunctionRepairAddressInfoStorage,
  MalfunctionRepairOrderDetailStorage,
} from '@/storage/malfunction-repair'
import {
  GetDeviceFlyLogsItem,
  NetworkListRenderItem,
  MalfunctionRepairFormFirstData,
  MalfunctionRepairServiceOrderDetail,
  MalfunctionRepairFormReceiveExpress,
  MalfunctionRepairCertificateListItem,
  MalfunctionRepairServiceOrderApplyInfo,
  MalfunctionRepairServiceOrderLogisticsItem,
  AreaStorageData,
} from '@/types/malfunction-repair'
import { USER_AFTERSALE_REPAIR_NEARBY_WAREHOUSE_AUTH } from '@/config/constant'
import { showToastSuccess } from '@/utils/tools'
import appHost from '@/utils/app'

let cacheLatLngInfo: null | {
  lat?: number | string
  lng?: number | string
  unAuth?: boolean
} = null // 缓存获取到经纬度信息
export function useMalfunctionRepairStore(): {
  malfunctionRepairState: MalfunctionRepairState
  selectedLogGuid: string
  changeSelectedLogGuid: (guid: string) => void
  initFlylogs: (sn: string) => Promise<GetDeviceFlyLogsItem[]>
  changeBoomValue: (bool: boolean) => void
  addNetworkListKeepAlive: () => void
  removeNetworkListKeepAlive: () => void
  addServiceOrderKeepAlive: () => void
  removeServiceOrderKeepAlive: () => void
  addFaultFormKeepAlive: () => void
  removeFaultFormKeepAlive: () => void
  addOrderRepairDetailItemKeepAlive: () => void
  addOrderDutyResultItemKeepAlive: () => void
  addFaultOrderListItemKeepAlive: () => void
  removeFaultOrderListItemKeepAlive: () => void
  removeOrderDutyResultItemKeepAlive: () => void
  removeOrderRepairDetailItemKeepAlive: () => void
  setNetworkInfo: (item: NetworkListRenderItem) => void
  setFormFirstData: (item: MalfunctionRepairFormFirstData) => void
  setSelectedLogItem: (item: GetDeviceFlyLogsItem) => void
  setCertificateData: (data: { sn: string; item: MalfunctionRepairCertificateListItem }) => void
  clearFormData: () => void
  getOrderApplyInfo: (guid: string) => Promise<MalfunctionRepairServiceOrderApplyInfo>
  setOrderDetailAddressInfo: (data: MalfunctionRepairServiceOrderLogisticsItem) => void
  getSubmitOrderSuccessGuid: () => string
  setSubmitOrderSuccessGuid: (guid: string) => void
  getUserLocation: (force?: boolean) => Promise<{
    lat?: string | number
    lng?: string | number
    unAuth?: boolean
  }>
  addUpdateMaintainOrderKeepAlive: () => void
  removeUpdateMaintainOrderKeepAlive: () => void
} {
  const $store = useStore()
  const { getUserLocationLngLatWithAuth } = useLocactionInfo()

  const malfunctionRepairState: MalfunctionRepairState = $store.state.MalfunctionRepair
  const changeSelectedLogGuid = (guid: string) => {
    $store.commit('MalfunctionRepair/setSelectedLogGuid', guid)
  }
  const initFlylogs = (sn: string): Promise<GetDeviceFlyLogsItem[]> => {
    return $store.dispatch('MalfunctionRepair/initFlylogs', sn)
  }
  const changeBoomValue = (bool: boolean) => {
    $store.commit('MalfunctionRepair/setBoomStatus', bool)
  }
  const addNetworkListKeepAlive = () => {
    $store.commit('MalfunctionRepair/addNetworkListKeepAlive')
  }
  const removeNetworkListKeepAlive = () => {
    $store.commit('MalfunctionRepair/removeNetworkListKeepAlive')
  }
  const setNetworkInfo = (item: NetworkListRenderItem) => {
    $store.commit('MalfunctionRepair/setNetworkInfo', item)
  }
  const setFormFirstData = (item: MalfunctionRepairFormFirstData) => {
    console.log('MalfunctionRepair/setFormFirstData', item)
    $store.commit('MalfunctionRepair/setFormFirstData', item)
  }
  const setSelectedLogItem = (item: GetDeviceFlyLogsItem) => {
    $store.commit('MalfunctionRepair/setSelectedLogItem', item)
  }
  const setCertificateData = (item: { sn: string; item: MalfunctionRepairCertificateListItem }) => {
    $store.commit('MalfunctionRepair/setCertificateData', item)
  }
  const clearFormData = () => {
    $store.commit('MalfunctionRepair/clearFormData')
  }
  const addServiceOrderKeepAlive = () => {
    $store.commit('MalfunctionRepair/addServiceOrderKeepAlive')
  }
  const removeServiceOrderKeepAlive = () => {
    $store.commit('MalfunctionRepair/removeServiceOrderKeepAlive')
  }
  const addOrderRepairDetailItemKeepAlive = () => {
    $store.commit('MalfunctionRepair/addOrderRepairDetailItemKeepAlive')
  }
  const removeOrderRepairDetailItemKeepAlive = () => {
    $store.commit('MalfunctionRepair/removeOrderRepairDetailItemKeepAlive')
  }
  const addFaultFormKeepAlive = () => {
    $store.commit('MalfunctionRepair/addFaultFormKeepAlive')
  }
  const removeFaultFormKeepAlive = () => {
    $store.commit('MalfunctionRepair/removeFaultFormKeepAlive')
  }
  const addOrderDutyResultItemKeepAlive = () => {
    $store.commit('MalfunctionRepair/addOrderDutyResultItemKeepAlive')
  }
  const removeOrderDutyResultItemKeepAlive = () => {
    $store.commit('MalfunctionRepair/removeOrderDutyResultItemKeepAlive')
  }
  const addFaultOrderListItemKeepAlive = () => {
    $store.commit('MalfunctionRepair/addFaultOrderListItemKeepAlive')
  }
  const removeFaultOrderListItemKeepAlive = () => {
    $store.commit('MalfunctionRepair/removeFaultOrderListItemKeepAlive')
  }
  const getOrderApplyInfo = (guid: string) => {
    const current = malfunctionRepairState.orderApplyInfoGuidMap[guid]
    if (current && current.status !== 'failed') {
      return current.data
    }
    return $store.dispatch('MalfunctionRepair/getOrderApplyInfo', guid)
  }
  const setOrderDetailAddressInfo = (item: MalfunctionRepairServiceOrderLogisticsItem) => {
    $store.commit('MalfunctionRepair/setOrderDetailAddressInfo', item)
  }
  const getSubmitOrderSuccessGuid = () => {
    const guid = malfunctionRepairState.submitOrderSuccessGuid
    malfunctionRepairState.submitOrderSuccessGuid = '' // 使用一次即清空
    return guid
  }
  const setSubmitOrderSuccessGuid = (guid: string) => {
    malfunctionRepairState.submitOrderSuccessGuid = guid
  }
  const getUserLocation = async (
    force = false
  ): Promise<{
    lat?: number | string
    lng?: number | string
    unAuth?: boolean
  }> => {
    if (cacheLatLngInfo && !force) {
      return Promise.resolve(cacheLatLngInfo)
    }
    try {
      const data = await getUserLocationLngLatWithAuth(USER_AFTERSALE_REPAIR_NEARBY_WAREHOUSE_AUTH)
      if (data?.lat && data?.lng) {
        cacheLatLngInfo = data
      }
      return data
    } catch (error) {
      return Promise.reject(error)
    }
  }
  const addUpdateMaintainOrderKeepAlive = () => {
    $store.commit('MalfunctionRepair/addUpdateMaintainOrderKeepAlive')
  }
  const removeUpdateMaintainOrderKeepAlive = () => {
    $store.commit('MalfunctionRepair/removeUpdateMaintainOrderKeepAlive')
  }
  return {
    malfunctionRepairState,
    selectedLogGuid: malfunctionRepairState.selectedLogGuid,
    changeSelectedLogGuid,
    initFlylogs,
    changeBoomValue,
    addNetworkListKeepAlive,
    removeNetworkListKeepAlive,
    setNetworkInfo,
    setFormFirstData,
    setSelectedLogItem,
    setCertificateData,
    clearFormData,
    getOrderApplyInfo,
    setOrderDetailAddressInfo,
    addServiceOrderKeepAlive,
    removeServiceOrderKeepAlive,
    addOrderRepairDetailItemKeepAlive,
    removeOrderRepairDetailItemKeepAlive,
    getSubmitOrderSuccessGuid,
    setSubmitOrderSuccessGuid,
    addFaultFormKeepAlive,
    removeFaultFormKeepAlive,
    addOrderDutyResultItemKeepAlive,
    removeOrderDutyResultItemKeepAlive,
    addFaultOrderListItemKeepAlive,
    removeFaultOrderListItemKeepAlive,
    getUserLocation,
    addUpdateMaintainOrderKeepAlive,
    removeUpdateMaintainOrderKeepAlive,
  }
}

export function useMalfunctionRepairAddressInfo(): {
  addressStr: string
  receive_express: MalfunctionRepairFormReceiveExpress
  getAddressStr: (expressInfo: MalfunctionRepairFormReceiveExpress) => string
  getAddressAreaStr: (params: { province: string; city: string; area: string }) => string
  getCacheAddressStr: () => string
} {
  // 由于地址数据不止一个单会使用，并希望不同设备能用上缓存的地址，所以需要特别存储使用，不保存在store
  const addressInfo: AreaStorageData = MalfunctionRepairAddressInfoStorage.get()
  const receive_express: MalfunctionRepairFormReceiveExpress = {
    name: addressInfo?.name || '',
    phone: addressInfo?.phone || '',
    province: addressInfo?.province || '',
    city: addressInfo?.city || '',
    area: addressInfo?.area || '',
    address: addressInfo?.address,
    province_id: addressInfo?.provinceID,
    city_id: addressInfo?.cityID,
    area_id: addressInfo?.areaID,
  }
  const { province, city, area, address } = receive_express
  const addressStr = `${province === city ? '' : province || ''}${city || ''}${area || ''}${
    address || ''
  }`
  function getAddressAreaStr(params: { province: string; city: string; area: string }) {
    const { province, city, area } = params
    return `${province === city ? '' : province}${city}${area}`
  }
  function getAddressStr(expressInfo: MalfunctionRepairFormReceiveExpress) {
    const { address } = expressInfo
    return `${getAddressAreaStr(expressInfo)}${address || ''}`
  }
  function getCacheAddressStr() {
    const addressInfo: AreaStorageData = MalfunctionRepairAddressInfoStorage.get()
    const receive_express: MalfunctionRepairFormReceiveExpress = {
      name: addressInfo?.name || '',
      phone: addressInfo?.phone || '',
      province: addressInfo?.province || '',
      city: addressInfo?.city || '',
      area: addressInfo?.area || '',
      address: addressInfo?.address,
      province_id: addressInfo?.provinceID,
      city_id: addressInfo?.cityID,
      area_id: addressInfo?.areaID,
    }
    return getAddressStr(receive_express)
  }
  return {
    receive_express,
    addressStr,
    getAddressStr,
    getAddressAreaStr,
    getCacheAddressStr,
  }
}

export function useCreateOrderSuccessHandle(): {
  createSuccessHandle: (guid: string, config?: { hasMoreDevices: boolean; is_pay: boolean }) => void
} {
  const { removeNetworkListKeepAlive, malfunctionRepairState, setSubmitOrderSuccessGuid } =
    useMalfunctionRepairStore()
  const $router = useRouter()
  const $route = useRoute()

  function createSuccessHandle(
    guid: string,
    config?: { hasMoreDevices: boolean; is_pay: boolean }
  ) {
    showToastSuccess('提单成功')
    setTimeout(() => {
      removeNetworkListKeepAlive() // 清除网点的缓存
      if (malfunctionRepairState?.hasUseCache && malfunctionRepairState?.useCacheId) {
        // 删除缓存
        appHost.deleteFaultReport(malfunctionRepairState.useCacheId)
        malfunctionRepairState.hasUseCache = false
      }
      malfunctionRepairState.useCacheId = ''
      console.log('$route', $route.name, $router)
      const isFaultSubmitPage = $route.name === 'malfunction-repair-fault-submit'
      if (isFaultSubmitPage) {
        setSubmitOrderSuccessGuid(guid)
        // 后退4页去到设备选择页，由onActivated判断到上一步设置的guid后跳转详情页
        console.log('$router', $router)
        if (config && !config.is_pay) {
          $router.go(-4)
        } else {
          $router.go(-3)
        }
      } else {
        // 理论上是六大类提单时触发
        const item = {
          name: 'malfunction-repair-fault-submit-success',
          query: {},
        }
        if (config && !config.hasMoreDevices) {
          item.query = {
            guid,
          }
        }
        $router.replace(item)
      }
    }, 2000)
  }
  return {
    createSuccessHandle,
  }
}

export function useMalfunctionRepairOrderDetailInfo(): {
  getOrderDetail: (guid: string, useCache?: boolean) => Promise<MalfunctionRepairServiceOrderDetail>
} {
  async function getOrderDetail(guid: string, useCache = true) {
    const cacheData = MalfunctionRepairOrderDetailStorage.get<MalfunctionRepairServiceOrderDetail>()
    try {
      const data =
        cacheData && cacheData.guid === guid && useCache
          ? cacheData
          : await getServiceOrderDetail(guid)
      // MalfunctionRepairOrderDetailStorage.set(data)
      return data
    } catch (error) {
      return Promise.reject(error)
    }
  }
  return {
    getOrderDetail,
  }
}

export function useMalfunctionRepairDeviceTimeFormat(): {
  serviceTimeFormat: (timeValue: string) => {
    start: string
    end: string
  }
} {
  function serviceTimeFormat(timeValue: string) {
    const arr = timeValue ? timeValue.split('-') : []
    return {
      start: arr[0] || '',
      end: arr[1] || '',
    }
  }
  return {
    serviceTimeFormat,
  }
}
